module.exports = __webpack_public_path__ + "img/statistics-bg.1a052fb4.png";